// extracted by mini-css-extract-plugin
module.exports = {"container":"ExternalLink_container__3ZPFx"};